import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Arkansas = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Arkansas Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Caveat emptor; no disclosure form required.
        </Text>

        <Text style={styles.listItem}>
          2. Property Disclosures: Not mandatory by state law but recommended.
        </Text>

        <Text style={styles.listItem}>
          3. Attorney Involvement: Optional, but many use an attorney for the
          title examination.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Sellers Disclosure Form</Text> – Not
          required according to law.
        </Text>
      </View>
    </View>
  );
};

export default Arkansas;
